import { FormattedMessage as FM } from "react-intl";

function CardInfo({ title, children }) {
  return (
    <div className="bg-white p-4 rounded-xl shadow-lg">
      <h2 className="text-xl text-center mx-auto text-neutral-600 font-bold">
        <FM id={`hotel.frontdesk.${title}`} key={title} />
      </h2>
      <div className="h-[3px] mx-auto mt-0 w-1/2 bg-amber-300" />
      {children}
    </div>
  );
}

export default CardInfo;
